import React, { memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';
import { HighlightWords, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientTitle = memo((props: Props) => {
  const { ingredientName, quantity } = props;

  const { formatMessage } = useIntl();

  const shouldUseQuantity = quantity !== undefined && quantity > 1;
  const quantityText = shouldUseQuantity ? `${quantity}x` : undefined;

  const text = quantityText
    ? formatMessage(messages.nameWithQuantity, { quantity: quantityText, name: ingredientName }) // prettier-ignore
    : ingredientName;

  return (
    <HighlightWords
      sizeMatch={['20']}
      text={text}
      highlights={quantityText ? [quantityText] : []}
      style={styles.text}
    />
  );
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  nameWithQuantity: {
    defaultMessage: '{quantity} {name}',
    description:
      'Customization | Active ingredient | Title | The name of the ingredient and its quantity',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  ingredientName: string;
  quantity: number | undefined;
};
